export default "__VITE_ASSET__C0Y0kDqp__"